<template>
  <form @submit.prevent="submitForm">

    <div class="mb-3">
      <label class="form-label">
        Select Site Transfer Mode
      </label>
      <div class="mb-1">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="siteTransferMode" id="input-site-transfer-mode-shipping" value="shipping" :checked="siteTransferMode == 'shipping'">
          <label class="form-check-label" for="input-site-transfer-mode-shipping">
            Shipping
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio" name="siteTransferMode" id="input-site-transfer-mode-receiving" value="receiving" :checked="siteTransferMode == 'receiving'">
          <label class="form-check-label" for="input-site-transfer-mode-receiving">
            Receiving
          </label>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <label for="input-sku" class="form-label">
        Enter SKU
      </label>
      <input type="text" v-model="sku" class="form-control" id="input-to-site-sku">
    </div>

    <div class="mb-3">
      <label for="scanned-skus" class="form-label">
        Scanned SKUs
      </label>
      <ul class="list-group">
        <li :class="selectedSkus.includes(sku) ? 'list-group-item active' : 'list-group-item'" v-for="(sku, index) in scannedSkus">
          <div class="row">
            <div class="col-8" @click="selectSku(sku)">
              {{ sku }}
            </div>
            <div class="col-4 text-right">
              <button type="button" class="btn btn-default btn-sm">
                View More
              </button>
            </div>
          </div>
        </li>
        <li class="list-group-item" v-if="scannedSkus.length == 0">
          Nothing scanned yet
        </li>
      </ul>
    </div>

    <div class="row mb-3">
      <div class="col-6">
        <button type="button" class="btn btn-secondary btn-sm btn-clear-selected" @click.prevent="clearSelected" :disabled="!scannedSkus.length">
          Clear Selected
        </button>
      </div>
      <div class="col-6 text-right">
        <button type="button" class="btn btn-secondary btn-sm btn-clear-all" @click.prevent="clearAll" :disabled="!scannedSkus.length">
          Clear All
        </button>
      </div>
    </div>

    <div class="mb-3">
      <label for="input-sku" class="form-label">
        Select Destination Site
      </label>
      <select v-model="destinationSites" class="form-control" id="input-destination-site">
        <option v-for="(transferId, index) in destinationSites" :value="transferId" :selected="0 == index">
          {{ transferId }}
        </option>
      </select>
    </div>

    <div class="d-grid gap-2 col-sm-6 mx-auto mt-4">
      <button type="submit" class="btn btn-success w-100 btn-process-site-transfer">
        Process Site Transfer
      </button>
    </div>


  </form>
</template>

<script>
  export default {
    name: 'ToSite',
    data() {
      return {
        sku : '',
        scannedSkus : [],
        selectedSkus : [],
        destinationSites : [],
        siteTransferMode: 'shipping',
      }
    },
    methods: {
      clearSelected() {
        this.selectedSkus.forEach(sku => this.removeSku(sku))
        this.selectedSkus.splice(0, this.selectedSkus.length)
      },
      clearAll() {
        this.selectedSkus.splice(0, this.selectedSkus.length)
        this.scannedSkus.splice(0, this.scannedSkus.length)
      },
      validateSku(e) {
        let enter = ( 'Enter' == e.key ? '' : '' )
        if ( 'Enter' == e.key ) {
          e.preventDefault()
          this.addSku(this.sku)
          this.sku = ''
        }
      },
      removeSku(sku) {
        this.scannedSkus.splice(this.scannedSkus.indexOf(sku), 1)
      },
      addSku(sku) {
        if ( sku ) {
          if ( this.scannedSkus.indexOf(sku) == -1 ) {
            this.scannedSkus.push(sku)
          }
        }
      },
      selectSku(sku) {
        if ( this.selectedSkus.includes(sku) ) {
          this.selectedSkus.splice(this.selectedSkus.indexOf(sku), 1)
        } else {
          this.selectedSkus.push(sku)
        }
      },
      submitForm() {
        const {
          sku,
          scannedSkus
        } = this
        console.log('xferToBinLocation', sku, scannedSkus)
      },

    }
  }
</script>
